module.exports = __webpack_public_path__ + "img/ls.f556fc78.svg";